import { z } from 'zod'

/**
 * `PUT /t/{slug}/admin/locale-settings` (TO-415) — SHAPE only: all three fields
 * required, no extras (→ `VALIDATION_ERROR`). The REQ-002 rules — list sizes,
 * duplicates, the tag pattern, `required ⊆ enabled`, `default ∈ enabled` — run
 * in user-service's pure validator so they answer `LOCALE_SETTINGS_INVALID`.
 * The element cap only bounds the payload.
 */
export const tenantLocaleSettingsSchema = z
	.object({
		enabledLocales: z.array(z.string().max(64)).max(100),
		requiredLocales: z.array(z.string().max(64)).max(100),
		defaultLocale: z.string().max(64),
	})
	.strict()

export type TenantLocaleSettingsInput = z.infer<typeof tenantLocaleSettingsSchema>
